import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const Container = styled.div`

  position: relative;
  margin-bottom: 12px;
  &.sepFullAdaptive {
    width: 100%;


  }
  &.apertura-content {
    display: flex;
    flex-direction: column;
    margin: 20px auto 20px;
    justify-content: flex-start;
    width: 100%;
    
    hr {
      display: block;
      width: 100%;
    }
  }
  &.mundialClubes-separator {
    scroll-margin-top: 140px;

    ${breakpoints.phone} {
      scroll-margin-top: 230px;
    }
  }

  &.especial-separator {
    scroll-margin-top: 140px;
    ${breakpoints.phone} {
      scroll-margin-top: 230px;
    }
  }

  ${breakpoints.phone} {
    width: 100%;
    margin: 10px auto;
  }
  hr {
    display: block;
    width: 100%;
    margin: 0;
    border: 0 none;
    height: auto;
    box-sizing: border-box;
    &:before {
      content: "";
      height: 1px;
      width: 100%;
      background: #e0e0e0;
      display: block;
      margin: 3px 0;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          background: ${ColorDark.greySeparator};
        }
      }
    }
    &:after {
      content: "";
      height: 1px;
      width: 100%;
      background: #e0e0e0;
      display: block;
      margin-top: 4px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          background: ${ColorDark.greySeparator};
        }
      }
    }
  }
`;
export const Section = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  height: 50px;
  //gap: 12px;
  justify-content: space-between;
  .left {
    display: flex;
  }
  .sponsorHead {
    max-width: 300px;
    max-height: 40px;
    overflow: hidden;
    display: flex;
    img {
      width: 100%;
      height: 40px;
    }
    #bannerTitle{
      ${Font.sansRegular};
      font-size: 11px;
      line-height: 40px;
      color: ${Color.grey};
      display: none;
      align-items: center;
    }

  }

  /* 1) Título + banner: 50% / 50% (no aplica a mundial ni especial-separator). */
  &.title-with-sponsor {
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    height: auto;
    min-height: 50px;

    .left {
      flex: 1 1 50%;
      min-width: 0;
      max-width: 50%;
    }
    .sponsorHead {
      flex: 1 1 50%;
      min-width: 0;
      max-width: 50%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      max-height: 50px;
      overflow: hidden;
      img {
        width: 100%;
        max-width: 100%;
        height: auto;
        max-height: 50px;
        object-fit: contain;
        object-position: right center;
      }
    }
  }
  &.title-with-sponsor.no-sponsor .sponsorHead {
    min-height: 0;
  }

  ${breakpoints.phone} {
    &.title-with-sponsor {
      flex-wrap: wrap;
      .left,
      .sponsorHead {
        flex: 1 1 100%;
        max-width: 100%;
      }
      .sponsorHead {
        justify-content: flex-start;
        img {
          object-position: left center;
        }
      }
    }
  }

  /* 3) Solo título: centrado + subrayado color marca (fuera de mundial / especial). */
&.no-sponsor.highlighted-title:not(.mundialClubes-separator):not(.especial-separator):not(.title-with-sponsor):not(.with-link) {
    justify-content: center;
    border-bottom: none;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-bottom: none;
      }
    }
    .left {
      width: 100%;
      justify-content: center;
    }
    .sep {
      margin-right: 0;
      text-align: center;
      border-bottom: 1px solid ${Color.mainColor};  
      line-height: 1.2;
      display: inline-block;
      padding-bottom: 2px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          border-bottom: 1px solid ${ColorDark.mainColor};
        }
      }
    }
    .sponsorHead {
      display: none;
    }
  }
  ${breakpoints.phone} {
    width: 100%;
    flex-wrap: wrap;
    padding: 10px 0;
    height: auto;
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
    }
  }
  p {
    display: none;
  }
  .sep {
    font-size: 18px;
    ${Font.sansBold};
    color: ${Color.black};
    margin-top: 3px;
    display: block;
    margin-right: 10px;

    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  &.apertura-content {
    width: 100%;
    border-bottom: none;
    justify-content: space-between;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-bottom: none;
      }
    }
    .sep {
      color: ${Color.mainColor};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.mainColor};
        }
      }
    }
  }
  &.apertura-content.no-sponsor.highlighted-title {
    justify-content: center;
    border-bottom: none;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-bottom: none;
      }
    }
    .left {
      width: auto;
      justify-content: center;
    }
    .sep {
      margin-right: 0;
      text-align: center;
      border-bottom: 1px solid ${Color.mainColor};
      line-height: 1.2;
      display: inline-block;
      padding-bottom: 2px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          border-bottom: 1px solid ${ColorDark.mainColor};
        }
      }
    }
  }
  &.especial-separator {
    border-bottom: 1px solid ${Color.greySeparator};
    border-top: 1px solid ${Color.greySeparator};

    justify-content: center;
    height: 105px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-bottom: 1px solid ${ColorDark.greySeparator};
        border-top: 1px solid ${ColorDark.greySeparator};
      }
    }
    ${breakpoints.phone} {
      height: 95px;
    }
    .sep {
      color: #fff;
      font-size: 32px;
      line-height: 46px;
      text-align: center;
      color: #4a4a4a;
      margin: -4px 0 0;
      ${breakpoints.phone} {
        font-size: 27px;
      }

      ${Font.clarinVarSub2Regular};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }

  &.mundialClubes-separator {
    justify-content: flex-start;
    height: 65px;
    ${breakpoints.phone} {
      flex-wrap: nowrap;
      height: auto;
      align-items: flex-start;
      padding: 0;
    }
    .left {
      order: 2;
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      ${breakpoints.phone} {
        flex-direction: column;
        flex-wrap: wrap;
      }
      .sep {
        color: #606060;
        font-size: 21px;
        line-height: 27px;
        margin-left: 15px;
        margin-top: -2px;
        ${breakpoints.phone} {
          margin-top: 2px;
        }
        ${breakpoints.darkMode} {
      [data-theme="dark"] & {
         color: ${ColorDark.textLight};
      }
    }
        @media (max-width: 372px) {
          font-size: 18px;
          line-height: 24px;
        }
        @media (max-width: 320px) {
          margin-top: -2px;
        }
      }
      .dd {
        ${breakpoints.phone} {
          margin-left: -50px;
          margin-top: 20px;
          border-top: 1px solid ${Color.greySeparator};
          padding: 12px 0;
        }
         ${breakpoints.darkMode} {
      [data-theme="dark"] & {
         border-top: 1px solid ${ColorDark.greySeparator};
      }
    }
      }
    }
    .sponsorHead {
      order: 1;
      overflow: visible;
      min-width: 50px;
      img {
        margin-top: -10px;
        width: 50px;
        height: 50px;
        object-fit: contain;
      }
    }
  }
`;

/** Solo imagen (sin título): franja a ancho del padre, alto acotado. Usado por containers vía Separator. */
export const SeparatorImageOnlyRoot = styled.div`
  width: 100%;
  margin-bottom: 6px;
  margin-top: 6px;

  a {
    display: block;
    width: 100%;
  }

  picture {
    display: block;
    width: 100%;
  }

  img {
    width: auto;
    max-height: 50px;
    display: block;
    object-position: left center;
  }

  ${breakpoints.phone} {
    img {
      max-height: 44px;
      width: 100%;
      object-position: left center;
    }
  }
`;

export const ExtraLink = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-left: 25px;
  ${breakpoints.phone} {
    margin-left: 0;
    row-gap: 10px;
  }
  li {
    padding: 5px 15px;
    border: 1px solid #000;
    border-radius: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border: 1px solid ${ColorDark.textLight};
      }
    }

    :first-child {
      position: relative;
      &:before {
        content: "";
        width: 1px;
        height: 30px;
        background: #e0e0e0;
        display: block;
        position: absolute;
        left: -21px;
        ${breakpoints.phone} {
          display: none;
        }
      }
    }
    a {
      font-size: 14px;
      ${Font.sansRegular};
      color: ${Color.black};
      transition-duration: 0.3s;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
      &:hover {
        color: #666;
      }
    }
    &.mundialClubes-separator {
      border: 1px solid #606060;
      ${breakpoints.darkMode} {
      [data-theme="dark"] & {
         border: 1px solid ${ColorDark.textLight};
      }
    }
      a {
        color: #606060;
        ${Font.sansBold};
        ${breakpoints.phone} {
          font-size: 10px;
          line-height: 13px;
        }
        ${breakpoints.darkMode} {
      [data-theme="dark"] & {
         color: ${ColorDark.textLight};
      }
    }
      }
      ::before {
        display: none;
      }
    }
  }
`;

export const HrDouble = styled.hr`
  width: 100%;
  margin: 0;
  border: 0 none;
  display: block;
  height: 10px;
  &:before {
    content: "";
    height: 1px;
    width: 100%;
    background: #e0e0e0;
    display: block;
    margin: 3px 0;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background: ${ColorDark.greySeparator};
      }
    }
  }
  &:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #e0e0e0;
    display: block;
    margin-top: 4px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background: ${ColorDark.greySeparator};
      }
    }
  }
`;

export const Skeleton = styled.div`
  width: 100%;
  height: ${props => props.$height || '50px'};
  /* COLOR POR DEFECTO: Blanco para modo claro */
  background-color: ${props => props.$backgroundColor || '#f5f5f5'};

  /* REGLA DE ORO: Si el HTML dice 'dark', pintalo oscuro YA MISMO */
  /* Esto no espera a React ni al JavaScript */
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      background-color: #1f1f1f !important;
    }
  }
`;